import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-thank-you',
  imports: [RouterModule, CommonModule],
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss'],
})
export class ThankYouComponent {
  emailProviderLink = '';
  userEmail: string | null = '';

  constructor(private route: ActivatedRoute) {
    const email = localStorage.getItem('sb_user_email'); // Store email temporarily on sign-up
    if (email) {
      this.userEmail = email;
      this.emailProviderLink = this.getEmailProviderLink(email);
    }
  }

  getEmailProviderLink(email: string): string {
    const domain = email.split('@')[1];
    switch (domain) {
      case 'gmail.com':
        return 'https://mail.google.com/';
      case 'yahoo.com':
        return 'https://mail.yahoo.com/';
      case 'outlook.com':
      case 'hotmail.com':
        return 'https://outlook.live.com/';
      default:
        return 'https://www.' + domain;
    }
  }
}
